import { getSafeReturnTo as libGetSafeReturnTo } from "@marekl/adminer";

/** Returns a safe same-origin return path; defaults to /dashboard. */
export function getSafeReturnTo(raw: string | null | undefined): string {
  return libGetSafeReturnTo(raw, { defaultPath: "/dashboard" });
}
